import { useState } from "react";
import { updateSchedule } from "@/mocks/manga";

export default function ScheduleSection() {
  const [activeDay, setActiveDay] = useState(updateSchedule[0].day);
  const active = updateSchedule.find((d) => d.day === activeDay) ?? updateSchedule[0];

  return (
    <section id="schedule" className="w-full bg-secondary-50 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-label text-secondary-700 uppercase tracking-widest">
            <i className="ri-calendar-line text-base" aria-hidden="true"></i>
            Update Calendar
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            本周更新日历：哪天有得看
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            把喜欢的那几部记下来，就能提前知道自己一周里哪天有更新，不用反复刷新。
            下方日期为本周对应更新日。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div
            role="tablist"
            aria-label="选择星期"
            className="lg:col-span-4 flex lg:flex-col gap-2 overflow-x-auto no-scrollbar pb-1"
          >
            {updateSchedule.map((day) => {
              const isActive = activeDay === day.day;
              return (
                <button
                  key={day.day}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActiveDay(day.day)}
                  className={`flex items-center justify-between gap-4 min-w-[9rem] px-4 py-3 rounded-lg border text-left transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "bg-secondary-500 border-secondary-500 text-background-50"
                      : "bg-background-50 border-background-200 text-foreground-800 hover:border-secondary-300"
                  }`}
                >
                  <span className="font-heading text-base font-bold">{day.day}</span>
                  <span
                    className={`text-xs font-label ${
                      isActive ? "text-background-50/80" : "text-foreground-500"
                    }`}
                  >
                    {day.date} · {day.items.length} 部
                  </span>
                </button>
              );
            })}
          </div>

          <div className="lg:col-span-8 rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className="ri-notification-2-line text-base" aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                {active.day}（{active.date}）更新 {active.items.length} 部
              </h3>
            </div>

            <ul key={active.day} className="mt-4 flex flex-col divide-y divide-background-200 animate-fade-up">
              {active.items.map((item) => (
                <li
                  key={`${item.title}-${item.chapter}`}
                  className="flex flex-wrap items-center justify-between gap-2 py-3.5"
                >
                  <div className="flex items-center gap-3 min-w-0">
                    <i className="ri-book-2-line text-secondary-500 text-lg" aria-hidden="true"></i>
                    <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                      {item.title}
                    </span>
                    <span className="text-xs font-label text-foreground-500">
                      {item.chapter}
                    </span>
                  </div>
                  <span className="px-2.5 py-1 rounded-md bg-background-100 text-xs font-label text-foreground-700">
                    {item.category}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}